import { render } from "./ResearchModeInfoTooltip.vue?vue&type=template&id=c2509c76&scoped=true"
import script from "./ResearchModeInfoTooltip.vue?vue&type=script&lang=js"
export * from "./ResearchModeInfoTooltip.vue?vue&type=script&lang=js"

import "./ResearchModeInfoTooltip.vue?vue&type=style&index=0&id=c2509c76&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2509c76"]])

export default __exports__